// dm_click bridge tracker — added 2026-09-17, System 13 §B.7 task 3.4
// Publishes a custom 'dm_click' analytics event whenever any WhatsApp/DM
// contact link is tapped anywhere on the site. Subscribed by the Customer
// Events custom pixel, which forwards it to Meta as "Contact".
// Reversible: delete this file + the one <script> line in snippets/scripts.liquid.
(function () {
  'use strict';

  function isDmLink(el) {
    if (!el || typeof el.closest !== 'function') return false;
    var a = el.closest('a[href], button[href]');
    if (!a) return false;
    var href = a.getAttribute('href') || '';
    return /wa\.me\//i.test(href) || /api\.whatsapp\.com\/send/i.test(href) || /^whatsapp:\/\//i.test(href);
  }

  function getItemId() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.page && meta.page.resourceType === 'product' && meta.product) {
        return String(meta.product.id);
      }
    } catch (e) {}
    return null;
  }

  document.addEventListener('click', function (e) {
    if (!isDmLink(e.target)) return;
    var payload = { source_page: window.location.pathname };
    var itemId = getItemId();
    if (itemId) payload.item_id = itemId;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('dm_click', payload);
      }
    } catch (err) {}
  }, true);
})();
